import { render } from "./VueExcelXlsx.vue?vue&type=template&id=55bc6f69"
import script from "./VueExcelXlsx.vue?vue&type=script&lang=js"
export * from "./VueExcelXlsx.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__